import { QueryFactory } from "../../../../Common";
import { Search } from "../../../../Contracts";
export const QSearch = QueryFactory(Search.QueryTypes.Search);
//# sourceMappingURL=QSearch.js.map